export enum DROPPABLETYPES {
  LAST_SONG = 'lastSongDroppable',
  WAITING_LIST = 'songListDroppable',
}
